import { render } from "./PostPage.vue?vue&type=template&id=52351810"
import script from "./PostPage.vue?vue&type=script&lang=js"
export * from "./PostPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__